let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ajQeC")).then(() => parcelRequire('7DKsD'));